import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class DividaServDesligadoPagtoService extends Service {
  async consultarTitulares () {
    let titulares = await this.getDividaServDesligadoPagtoApi().consultarTitulares();
    return titulares || [];
  }
  async consultarTitularesComDivida () {
    let titulares = await this.getDividaServDesligadoPagtoApi().consultarTitularesComDivida();
    return titulares || [];
  }
  async consultarPagtos (numMatricula, dataInicial, dataFinal, apenasSemBaixa) {
    let pagtos = [];
    let brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    let result = await this.getDividaServDesligadoPagtoApi().consultarPagtos(numMatricula, dataInicial, dataFinal, apenasSemBaixa);
    result.map(res => {
      const { numPagto, seqBeneficiario, numMatricula, nomeBeneficiario, dtaPagto, dtaCadastro,	valPagto, txtObservacao, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, valTotalBaixado, baixas, txtDocBanco } = res;
      if (codUsuarioCancelamento.trim() !== '') {
        tipoBotaoCancelamento = 'DESFAZER';
      } else {
        tipoBotaoCancelamento = 'CANCELAR';
      }
      pagtos.push(Object.values({ numPagto, seqBeneficiario, numMatricula, nomeBeneficiario, dtaPagto, dtaCadastro,	valPagto, txtObservacao, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, valTotalBaixado, baixas, txtDocBanco, tipoBotaoCancelamento, brancoAcoes }));
    });
    return pagtos || [];
  }
  async incluirPagto (pagto) {
    let result = await this.getDividaServDesligadoPagtoApi().incluirPagto(pagto);
    return result;
  }
  async alterarPagto (pagto) {
    let result = await this.getDividaServDesligadoPagtoApi().alterarPagto(pagto);
    return result;
  }
  async excluirPagto (pagto) {
    let result = await this.getDividaServDesligadoPagtoApi().excluirPagto(pagto);
    return result;
  }
  async cancelarPagto (numPagto, motivoCancelamento) {
    const result = await this.getDividaServDesligadoPagtoApi().cancelarPagto(numPagto, motivoCancelamento);
    return result;
  }
  async desfazerCancelamentoPagto (numPagto) {
    const result = await this.getDividaServDesligadoPagtoApi().desfazerCancelamentoPagto(numPagto);
    return result;
  }
  async baixarPagto (pagto) {
    let result = await this.getDividaServDesligadoPagtoApi().baixarPagto(pagto);
    return result || [];
  }
}
export default DividaServDesligadoPagtoService;
